module.exports = __webpack_public_path__ + "media/images/faramia/signature-d1d12e2ec197c63ec183e7f788c614b5.png";